"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.reduce.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _index2 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _leadsProducts = require("@/api/leads-products");
var _leads = require("@/api/leads");
var _productsVariations = require("@/api/products-variations");
var _settings = require("@/api/settings");
var _reasons = require("@/api/master/reasons");
var _admin = require("@/store/modules/admin");
var _LeadsProductGrid = _interopRequireDefault(require("./components/LeadsProductGrid.vue"));
var _router = _interopRequireDefault(require("@/router"));
require("tinymce/tinymce");
require("tinymce/themes/silver");
require("tinymce/icons/default");
require("tinymce/skins/ui/oxide/skin.css");
var _tinymceVue = _interopRequireDefault(require("@tinymce/tinymce-vue"));
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/image");
require("tinymce/plugins/paste");
require("tinymce/plugins/help");
require("tinymce/plugins/wordcount");
require("tinymce/plugins/preview");
require("tinymce/plugins/table");
require("tinymce/plugins/code");
// import { Action } from 'vuex-module-decorators'

// tinymce plugins

let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.leadsProductList = [];
    this.listLoading = true;
    this.leadId = 0;
    this.lead = null;
    this.selectedProduct = null;
    this.productList = [];
    this.addedProductIds = [];
    this.customProduct = false;
    this.loggedInUser = null;
    this.rejectDialogVisible = false;
    this.previewDialogVisible = false;
    this.rejectReason = '';
    this.rejectReasonComment = '';
    this.reasonId = null;
    this.reasonList = [];
    this.previewPdfUrl = '';
    this.optionPreviewUrl = '';
    this.loading = false;
    this.previewLoading = false;
    this.rejectLoading = false;
    this.approveLoading = false;
    this.sendDirectLoading = false;
    this.defaultQuoteExtraNote = '<p><strong>Extra / Totaling Notes</strong></p><p>1. Transportation charges, if applicable, are extra.</p><p>2. Taxes and statutory levies are extra as applicable.</p><p>3. Final totaling will be based on confirmed quantities and negotiated rates.</p>';
  }
  get addedVariationIds() {
    return this.leadsProductList.map(p => {
      var _p$productsVariation;
      return p.productVariationId || ((_p$productsVariation = p.productsVariation) === null || _p$productsVariation === void 0 ? void 0 : _p$productsVariation.id);
    }).filter(Boolean);
  }
  get presentationEnabled() {
    return process.env.VUE_APP_PRESENTATION_ENABLED === 'true';
  }
  get negotiatedPriceLimitMultiplier() {
    return process.env.VUE_APP_NEGOTIATED_PRICE_LIMIT_MULTIPLIER !== undefined ? Number(process.env.VUE_APP_NEGOTIATED_PRICE_LIMIT_MULTIPLIER) : 0;
  }
  get sendDirectlyToClientLimit() {
    return process.env.VUE_APP_SEND_DIRECTLY_TO_CLIENT_LIMIT !== undefined ? Number(process.env.VUE_APP_SEND_DIRECTLY_TO_CLIENT_LIMIT) : Infinity;
  }
  get isInstec() {
    return process.env.VUE_APP_PROJECT === 'instec';
  }
  // Instec has no lead-level discount; it is applied per product on the unit rate
  get leadDiscount() {
    return this.isInstec ? 0 : Number(this.lead.discount) || 0;
  }
  created() {
    this.leadId = +(this.$route.params && this.$route.params.id);
    this.getList();
    this.loggedInUser = _admin.AdminModule;
    // fetch rejection reasons
    this.fetchReasonList();
  }
  handlProductOptions(data) {
    this.addProductOptions(data);
  }
  disableInputs() {
    const readonly = false;
    if (this.loggedInUser.roles.indexOf('Super Admin') > -1 &&
    // this.loggedInUser.email === 'mubasshir@eiosys.com' &&
    this.lead.quotationStatus !== 'Request Options Approval') {
      // readonly = true
    }
    return readonly;
  }
  formatAmount(value) {
    const amount = Number(value);
    const safeAmount = Number.isFinite(amount) ? amount : 0;
    return safeAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  formatCurrency(value) {
    return `₹${this.formatAmount(value)}`;
  }
  formatInteger(value) {
    const count = Number(value);
    const safeCount = Number.isFinite(count) ? count : 0;
    return safeCount.toLocaleString('en-IN', {
      maximumFractionDigits: 0
    });
  }
  updateGrandTotal() {
    // 1. Product tax total
    const taxedAmount = this.leadsProductList.reduce((sum, item) => {
      return sum + (Number(item.taxAmount) || 0);
    }, 0);
    // 2. Product total (sum of all products)
    const productsTotal = this.leadsProductList.reduce((sum, item) => {
      return sum + (Number(item.subTotal) || 0);
    }, 0);
    // ✅ SWAPPED (products total should go in total)
    this.$set(this.lead, 'total', Number(productsTotal.toFixed(2)));
    this.$set(this.lead, 'taxAmount', Number(taxedAmount.toFixed(2)));
    const transport = Number(this.lead.transportChargesValue) || 0;
    // Recalculate packing on discounted product total
    const discount = this.leadDiscount;
    const discountedTotal = productsTotal - discount;
    const packingPercentage = Number(this.lead.packingChargesPercentage) || 0;
    if (packingPercentage > 0) {
      this.lead.packingChargesValue = Number((discountedTotal * packingPercentage / 100).toFixed(2));
    }
    this.lead.packingChargesAmount = this.lead.packingChargesValue;
    const packing = Number(this.lead.packingChargesValue) || 0;
    // 3. Transport tax
    const transportTax = transport * 18 / 100;
    // 4. Packing tax
    const packingTax = packing * 18 / 100;
    // 5. Total Tax Amount
    const totalTaxedAmount = taxedAmount + transportTax + packingTax;
    this.$set(this.lead, 'transportTax', Number(transportTax.toFixed(2)));
    this.$set(this.lead, 'packingTax', Number(packingTax.toFixed(2)));
    this.$set(this.lead, 'totalTaxedAmount', Number(totalTaxedAmount.toFixed(2)));
    // ✅ Subtotal should be products + charges (before tax)
    const subTotal = productsTotal + transport + packing;
    this.$set(this.lead, 'subTotal', Number(subTotal.toFixed(2)));
    // 6. Grand Total (subtotal + taxes)
    const grandTotal = subTotal + totalTaxedAmount - discount;
    this.$set(this.lead, 'grandTotal', Number(grandTotal.toFixed(2)));
  }
  handleTransportPercentageChange() {
    const subTotal = Number(this.lead.subTotal) || 0;
    const percentage = Number(this.lead.transportChargesPercentage) || 0;
    this.lead.transportChargesValue = Number((subTotal * percentage / 100).toFixed(2));
    const total = Number(this.lead.total) || 0;
    this.lead.transportChargesValue = Number((total * percentage / 100).toFixed(2));
    this.updateGrandTotal(); // <-- Added
  }
  onLeadTotalChanged(newTotal, oldTotal) {
    if (newTotal !== oldTotal) {
      this.handleTransportPercentageChange();
      this.handlePackingPercentageChange();
      this.handleDiscountPercentageChange();
    }
  }
  handleTransportValueChange() {
    const subTotal = Number(this.lead.subTotal) || 0;
    const value = Number(this.lead.transportChargesValue) || 0;
    if (subTotal > 0) {
      this.lead.transportChargesPercentage = Number((value / subTotal * 100).toFixed(2));
    } else {
      this.lead.transportChargesPercentage = 0;
    }
    const total = Number(this.lead.total) || 0;
    if (total > 0) {
      this.lead.transportChargesPercentage = Number((value / total * 100).toFixed(2));
    } else {
      this.lead.transportChargesPercentage = 0;
    }
    this.updateGrandTotal(); // <-- Added
  }
  // --- Packing Charges Logic ---
  handlePackingPercentageChange() {
    const total = Number(this.lead.total) || 0;
    const discount = this.leadDiscount;
    const discountedTotal = total - discount;
    const percentage = Number(this.lead.packingChargesPercentage) || 0;
    this.lead.packingChargesValue = Number((discountedTotal * percentage / 100).toFixed(2));
    this.updateGrandTotal(); // <-- Added
  }
  handlePackingValueChange() {
    const total = Number(this.lead.total) || 0;
    const discount = this.leadDiscount;
    const discountedTotal = total - discount;
    const value = Number(this.lead.packingChargesValue) || 0;
    if (discountedTotal > 0) {
      this.lead.packingChargesPercentage = Number((value / discountedTotal * 100).toFixed(2));
    } else {
      this.lead.packingChargesPercentage = 0;
    }
    this.updateGrandTotal(); // <-- Added
  }
  handleDiscountPercentageChange() {
    if (this.isInstec) {
      this.lead.discountPercentage = 0;
      this.lead.discount = 0;
      return;
    }
    const subTotal = Number(this.lead.subTotal) || 0;
    const percentage = Number(this.lead.discountPercentage) || 0;
    this.lead.discount = Number((subTotal * percentage / 100).toFixed(2));
    const total = Number(this.lead.total) || 0;
    this.lead.discount = Number((total * percentage / 100).toFixed(2));
    this.updateGrandTotal();
  }
  handleDiscountValueChange() {
    if (this.isInstec) {
      this.lead.discountPercentage = 0;
      this.lead.discount = 0;
      return;
    }
    const subTotal = Number(this.lead.subTotal) || 0;
    const value = Number(this.lead.discount) || 0;
    if (subTotal > 0) {
      this.lead.discountPercentage = Number((value / subTotal * 100).toFixed(2));
    } else {
      this.lead.discountPercentage = 0;
    }
    const total = Number(this.lead.total) || 0;
    if (total > 0) {
      this.lead.discountPercentage = Number((value / total * 100).toFixed(2));
    } else {
      this.lead.discountPercentage = 0;
    }
    this.updateGrandTotal();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await (0, _leadsProducts.getLeadsProducts)((0, _index.getQuery)({
        leadId: this.leadId,
        filter: {
          leadId: '$eq'
        }
      }));
      // API returns DECIMAL columns as strings; el-input-number needs real numbers
      this.leadsProductList = (data || []).map(item => ({
        ...item,
        quantity: Number(item.quantity) || 0,
        unitPrice: Number(item.unitPrice) || 0,
        salePrice: Number(item.salePrice) || 0,
        discount: Number(item.discount) || 0
      }));
      if (this.leadsProductList && this.leadsProductList.length) {
        this.leadsProductList.forEach((_, index) => {
          this.calculate(index);
        });
      }
      // get lead info
      // Do this instead:
      this.lead = await (0, _leads.getLeadById)(this.leadId);
      if (this.isInstec) {
        this.lead.discount = 0;
        this.lead.discountPercentage = 0;
      }
      this.$nextTick(() => this.updateGrandTotal());
      let globalSettings = null;
      try {
        globalSettings = await (0, _settings.getSettingById)(1);
      } catch (e) {
        console.error('Failed to fetch global settings', e);
      }
      const defaultTnc = '<p>1. Delivery&nbsp; &nbsp; &nbsp; &nbsp; : F.O.R. [location], within [number] days from date of receipt of purchase order<br />2. Printing&nbsp; &nbsp; &nbsp; &nbsp; : Inclusive of single-color brand name printing on each product<br />3. Packaging&nbsp; &nbsp;: Each set in [number] color [type] box then bulk packing in [number] ply master carton<br />4. Payment&nbsp; &nbsp; &nbsp; : [number] days from the date of delivery of goods<br /><br /></p>\n<p>The above quotation is valid for one week only &amp; subject to our reconfirmation.</p>';
      const defaultExtra = '<p><strong>Extra / Totaling Notes</strong></p><p>1. Transportation charges, if applicable, are extra.</p><p>2. Taxes and statutory levies are extra as applicable.</p><p>3. Final totaling will be based on confirmed quantities and negotiated rates.</p>';
      if (!this.lead.tnc || this.lead.tnc === defaultTnc) {
        var _globalSettings;
        this.lead.tnc = ((_globalSettings = globalSettings) === null || _globalSettings === void 0 ? void 0 : _globalSettings.termsAndConditions) || defaultTnc;
      }
      if (!this.lead.quoteExtraNote || this.lead.quoteExtraNote === defaultExtra) {
        var _globalSettings2;
        this.lead.quoteExtraNote = ((_globalSettings2 = globalSettings) === null || _globalSettings2 === void 0 ? void 0 : _globalSettings2.quotationAdditionalNote) || defaultExtra;
      }
      if (this.lead.productAction === 'Send Quote') {
        this.customProduct = true;
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async addProduct() {
    var _this$selectedProduct, _this$selectedProduct2, _this$selectedProduct3, _this$selectedProduct4, _this$selectedProduct5, _this$selectedProduct6, _this$selectedProduct7, _this$selectedProduct8, _this$selectedProduct9;
    console.log('Selected Product:', this.selectedProduct);
    // check if product is selected
    if (!this.selectedProduct) {
      console.log('No product selected');
      this.$message({
        message: 'Please select product',
        type: 'warning'
      });
      return false;
    }
    console.log('Added Product IDs:', this.addedProductIds);
    console.log('Selected Product ID:', this.selectedProduct.id);
    // check if product already added
    if (this.addedProductIds.includes(this.selectedProduct.id)) {
      console.log('Product already added');
      this.$message({
        message: 'Product already added',
        type: 'warning'
      });
      return false;
    }
    console.log('Product Images:', (_this$selectedProduct = this.selectedProduct) === null || _this$selectedProduct === void 0 || (_this$selectedProduct = _this$selectedProduct.product) === null || _this$selectedProduct === void 0 ? void 0 : _this$selectedProduct.productsImage);
    console.log('First Image:', (_this$selectedProduct2 = this.selectedProduct) === null || _this$selectedProduct2 === void 0 || (_this$selectedProduct2 = _this$selectedProduct2.product) === null || _this$selectedProduct2 === void 0 || (_this$selectedProduct2 = _this$selectedProduct2.productsImage) === null || _this$selectedProduct2 === void 0 || (_this$selectedProduct2 = _this$selectedProduct2[0]) === null || _this$selectedProduct2 === void 0 ? void 0 : _this$selectedProduct2.image);
    if (!((_this$selectedProduct3 = this.selectedProduct) !== null && _this$selectedProduct3 !== void 0 && (_this$selectedProduct3 = _this$selectedProduct3.product) !== null && _this$selectedProduct3 !== void 0 && (_this$selectedProduct3 = _this$selectedProduct3.productsImage) !== null && _this$selectedProduct3 !== void 0 && (_this$selectedProduct3 = _this$selectedProduct3[0]) !== null && _this$selectedProduct3 !== void 0 && _this$selectedProduct3.image)) {
      console.log('Image missing for product');
      this.$message({
        message: 'Please add product image before selecting',
        type: 'warning'
      });
      return false;
    }
    let unitPrice = this.selectedProduct.unitPrice;
    let salePrice = this.selectedProduct.unitPrice;
    console.log('Initial Prices:', {
      unitPrice: this.selectedProduct.unitPrice,
      salePrice: this.selectedProduct.salePrice,
      quotePrice: this.selectedProduct.quotePrice
    });
    if (this.selectedProduct.quotePrice && this.selectedProduct.quotePrice > 0) {
      unitPrice = this.selectedProduct.quotePrice;
      salePrice = this.selectedProduct.quotePrice;
    } else if (this.selectedProduct.salePrice && this.selectedProduct.salePrice > 0) {
      unitPrice = this.selectedProduct.salePrice;
      salePrice = this.selectedProduct.salePrice;
    }
    console.log('Final Prices:', {
      unitPrice,
      salePrice
    });
    const image = ((_this$selectedProduct4 = this.selectedProduct) === null || _this$selectedProduct4 === void 0 || (_this$selectedProduct4 = _this$selectedProduct4.product) === null || _this$selectedProduct4 === void 0 || (_this$selectedProduct4 = _this$selectedProduct4.productsImage) === null || _this$selectedProduct4 === void 0 ? void 0 : _this$selectedProduct4.length) > 0 ? ((_this$selectedProduct5 = this.selectedProduct) === null || _this$selectedProduct5 === void 0 || (_this$selectedProduct5 = _this$selectedProduct5.product.productsImage.find(img => img.isCover)) === null || _this$selectedProduct5 === void 0 ? void 0 : _this$selectedProduct5.image) || ((_this$selectedProduct6 = this.selectedProduct) === null || _this$selectedProduct6 === void 0 || (_this$selectedProduct6 = _this$selectedProduct6.product) === null || _this$selectedProduct6 === void 0 || (_this$selectedProduct6 = _this$selectedProduct6.productsImage[0]) === null || _this$selectedProduct6 === void 0 ? void 0 : _this$selectedProduct6.image) : null;
    console.log('Selected Image:', image);
    console.log('tax ', (_this$selectedProduct7 = this.selectedProduct.product) === null || _this$selectedProduct7 === void 0 ? void 0 : _this$selectedProduct7.taxId);
    this.leadsProductList.push({
      enabled: true,
      leadId: this.leadId,
      productId: this.selectedProduct.productId,
      productVariationId: this.selectedProduct.productVariationId || this.selectedProduct.id,
      productName: this.selectedProduct.name,
      productsVariation: this.selectedProduct,
      unitPrice: unitPrice,
      salePrice: salePrice,
      quantity: 1,
      discount: 0,
      discountAmount: 0,
      subTotal: 0,
      total: 0,
      image1: image,
      tax: {
        id: ((_this$selectedProduct8 = this.selectedProduct.product) === null || _this$selectedProduct8 === void 0 ? void 0 : _this$selectedProduct8.taxId) || null,
        rate: ((_this$selectedProduct9 = this.selectedProduct.product) === null || _this$selectedProduct9 === void 0 || (_this$selectedProduct9 = _this$selectedProduct9.tax) === null || _this$selectedProduct9 === void 0 ? void 0 : _this$selectedProduct9.rate) || 0
      }
    });
    console.log('Updated leadsProductList:', this.leadsProductList);
    this.calculate(this.leadsProductList.length - 1);
    this.addedProductIds.push(this.selectedProduct.id);
    console.log('Updated addedProductIds:', this.addedProductIds);
  }
  addProductOptions(selectedProducts) {
    // check existing variation ids (allow multiple variations of same product)
    this.addedProductIds = this.leadsProductList.map(leadsProduct => {
      var _leadsProduct$product;
      return leadsProduct.productVariationId || ((_leadsProduct$product = leadsProduct.productsVariation) === null || _leadsProduct$product === void 0 ? void 0 : _leadsProduct$product.id);
    }).filter(id => !!id);
    let isProductAlreadyAdded = false;
    selectedProducts.forEach(product => {
      const variationId = product.productVariationId || product.id;
      if (variationId && this.addedProductIds.includes(variationId)) {
        this.$message({
          message: 'Product variation already added',
          type: 'warning'
        });
        isProductAlreadyAdded = true;
      }
    });
    if (isProductAlreadyAdded) {
      return false;
    }
    if (selectedProducts.length) {
      for (const item of selectedProducts) {
        var _item$product, _item$product2, _item$product$product, _item$product$product2, _item$product3, _item$product4;
        console.log('Processing item:', item);
        console.log('Product image check:', (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.productsImage);
        // if (!item.product?.productsImage?.[0]?.image) {
        //   console.log('Image missing for product:', item)
        //   this.$message({
        //     message: 'Please add product image before selecting',
        //     type: 'warning'
        //   })
        //   return false
        // }
        let unitPrice = item.unitPrice;
        let salePrice = item.unitPrice;
        if (item.quotePrice && item.quotePrice > 0) {
          unitPrice = item.quotePrice;
          salePrice = item.quotePrice;
        } else if (item.salePrice && item.salePrice > 0) {
          unitPrice = item.salePrice;
          salePrice = item.salePrice;
        }
        const newProduct = {
          enabled: true,
          leadId: this.leadId,
          productId: item.productId,
          productVariationId: item.productVariationId || item.id,
          productName: item.name,
          productsVariation: item,
          unitPrice: unitPrice,
          salePrice: salePrice,
          margin: item.margin,
          quantity: this.lead.quantity,
          discount: 0,
          discountAmount: 0,
          subTotal: 0,
          total: 0,
          image1: ((_item$product2 = item.product) === null || _item$product2 === void 0 || (_item$product2 = _item$product2.productsImage) === null || _item$product2 === void 0 ? void 0 : _item$product2.length) > 0 ? ((_item$product$product = item.product.productsImage.find(img => img.isCover)) === null || _item$product$product === void 0 ? void 0 : _item$product$product.image) || ((_item$product$product2 = item.product.productsImage[0]) === null || _item$product$product2 === void 0 ? void 0 : _item$product$product2.image) : null,
          taxId: ((_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.taxId) || null,
          taxRate: ((_item$product4 = item.product) === null || _item$product4 === void 0 || (_item$product4 = _item$product4.tax) === null || _item$product4 === void 0 ? void 0 : _item$product4.rate) || 0
        };
        this.leadsProductList.push(newProduct);
        this.calculate(this.leadsProductList.length - 1);
      }
    } else {
      this.$message({
        message: 'Please select atleast one product',
        type: 'warning'
      });
      return false;
    }
  }
  async addCustomProduct() {
    var _this$selectedProduct0, _this$selectedProduct1, _this$selectedProduct10, _this$selectedProduct11, _this$selectedProduct12, _this$selectedProduct13, _this$selectedProduct14, _this$selectedProduct15, _this$selectedProduct16;
    if (!((_this$selectedProduct0 = this.selectedProduct.product) !== null && _this$selectedProduct0 !== void 0 && (_this$selectedProduct0 = _this$selectedProduct0.productsImage[0]) !== null && _this$selectedProduct0 !== void 0 && _this$selectedProduct0.image)) {
      this.$message({
        message: 'Please add product image before selecting',
        type: 'warning'
      });
      return false;
    }
    let unitPrice = this.selectedProduct.unitPrice;
    let salePrice = this.selectedProduct.unitPrice;
    if (this.selectedProduct.quotePrice && this.selectedProduct.quotePrice > 0) {
      unitPrice = this.selectedProduct.quotePrice;
      salePrice = this.selectedProduct.quotePrice;
    } else if (this.selectedProduct.salePrice && ((_this$selectedProduct1 = this.selectedProduct) === null || _this$selectedProduct1 === void 0 ? void 0 : _this$selectedProduct1.salePrice) > 0) {
      unitPrice = this.selectedProduct.salePrice;
      salePrice = this.selectedProduct.salePrice;
    }
    this.leadsProductList.push({
      enabled: true,
      leadId: this.leadId,
      productId: null,
      productName: ((_this$selectedProduct10 = this.selectedProduct) === null || _this$selectedProduct10 === void 0 ? void 0 : _this$selectedProduct10.name) || '',
      productsVariationId: null,
      unitPrice: unitPrice,
      salePrice: salePrice,
      margin: ((_this$selectedProduct11 = this.selectedProduct) === null || _this$selectedProduct11 === void 0 ? void 0 : _this$selectedProduct11.margin) || 0,
      quantity: this.lead.quantity,
      discount: 0,
      discountAmount: 0,
      subTotal: 0,
      total: 0,
      image1: ((_this$selectedProduct12 = this.selectedProduct.product) === null || _this$selectedProduct12 === void 0 || (_this$selectedProduct12 = _this$selectedProduct12.productsImage) === null || _this$selectedProduct12 === void 0 ? void 0 : _this$selectedProduct12.length) > 0 ? (_this$selectedProduct13 = this.selectedProduct.product.productsImage.find(img => img.isCover)) === null || _this$selectedProduct13 === void 0 ? void 0 : _this$selectedProduct13.image : (_this$selectedProduct14 = this.selectedProduct.product) === null || _this$selectedProduct14 === void 0 || (_this$selectedProduct14 = _this$selectedProduct14.productsImage[0]) === null || _this$selectedProduct14 === void 0 ? void 0 : _this$selectedProduct14.image,
      taxId: ((_this$selectedProduct15 = this.selectedProduct.product) === null || _this$selectedProduct15 === void 0 ? void 0 : _this$selectedProduct15.taxId) || null,
      taxRate: ((_this$selectedProduct16 = this.selectedProduct.product) === null || _this$selectedProduct16 === void 0 || (_this$selectedProduct16 = _this$selectedProduct16.tax) === null || _this$selectedProduct16 === void 0 ? void 0 : _this$selectedProduct16.rate) || 0
    });
    this.calculate(this.leadsProductList.length - 1);
  }
  async saveProducts(isPreview = false) {
    try {
      if (isPreview !== true) {
        await this.$confirm('Are you sure you want to send this?', 'Confirmation', {
          confirmButtonText: 'Yes, Send',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
      }
      this.listLoading = true;
      if (this.leadsProductList.length) {
        for (const product of this.leadsProductList) {
          if (product.unitPrice < 1) {
            this.$notify({
              title: 'Error',
              type: 'error',
              message: 'Products price should not be 0'
            });
            this.listLoading = false;
            return; // Bug fix: halts execution
          }
        }
        this.leadsProductList[0].isPreview = isPreview;
        this.saveForm();
        // Fully restored payload mapping
        const payload = this.leadsProductList.map(p => {
          var _p$productsVariation2;
          return {
            id: p.id,
            leadId: p.leadId,
            productId: p.productId,
            productVariationId: p.productVariationId || p.productsVariationId,
            productsVariationId: p.productsVariationId || p.productVariationId,
            productName: p.productName,
            name: p.name,
            sku: p.sku,
            hsnCode: p.hsnCode || ((_p$productsVariation2 = p.productsVariation) === null || _p$productsVariation2 === void 0 || (_p$productsVariation2 = _p$productsVariation2.product) === null || _p$productsVariation2 === void 0 ? void 0 : _p$productsVariation2.hsnCode),
            image1: p.image1,
            quantity: p.quantity,
            unitPrice: p.unitPrice,
            salePrice: p.salePrice,
            quotePrice: p.quotePrice,
            closingPrice: p.closingPrice,
            tax: p.tax,
            taxId: p.taxId,
            taxRate: p.taxRate,
            taxAmount: p.taxAmount,
            margin: p.margin,
            discount: this.isInstec ? Number(p.discount) || 0 : p.discount,
            discountAmount: this.isInstec ? Number(p.discountAmount) || 0 : 0,
            comments: p.comments,
            quoteComments: p.quoteComments,
            additionalChargesTotal: p.additionalChargesTotal,
            isPreview: p.isPreview
          };
        });
        const res = await (0, _leadsProducts.addLeadsProducts)(payload);
        this.$notify({
          title: 'Success',
          message: 'Products saved',
          type: 'success',
          duration: 2000
        });
        if (isPreview) {
          const pdfUrl = await (0, _leads.previewPdfUrl)(this.leadId);
          const routeData = _router.default.resolve({
            path: '/quote-preview',
            query: {
              file: pdfUrl
            }
          });
          window.open(routeData.href, '_blank');
        }
        if (!isPreview) {
          _router.default.push('/follow-ups/list/' + this.leadId);
        } else {
          this.getList();
        }
      } else {
        this.$message({
          message: 'Please add atleast one product',
          type: 'warning'
        });
      }
    } catch (error) {
      if (error !== 'cancel') {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: error.toString()
        });
      }
    } finally {
      this.listLoading = false;
    }
  }
  async requestApproval() {
    try {
      await this.$confirm('Are you sure you want to send this for approval?', 'Confirmation', {
        confirmButtonText: 'Yes, Send',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      this.listLoading = true;
      await this.saveForm();
      for (const product of this.leadsProductList) {
        if (product.unitPrice < 1) {
          this.$notify({
            title: 'Error',
            type: 'error',
            message: 'Products price should not be 0'
          });
        }
      }
      await (0, _leadsProducts.addLeadsProducts)(this.leadsProductList);
      // if (!this.lead.pdfUrl) {
      // await previewPdfUrl(this.leadId)
      // }
      const res = await (0, _leads.sendForAdminApproval)({
        id: this.leadId
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      if (error !== 'cancel') {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: error.toString()
        });
      }
    } finally {
      this.listLoading = false;
    }
  }
  async sendDirectToClientHandler() {
    if (this.sendDirectlyToClientLimit !== Infinity && this.lead.grandTotal >= this.sendDirectlyToClientLimit) {
      this.$message({
        message: `Grand total must be less than ₹${this.sendDirectlyToClientLimit.toLocaleString('en-IN')} to send directly to client`,
        type: 'warning'
      });
      return false;
    }
    try {
      await this.$confirm('Are you sure you want to send this directly to the client?', 'Confirmation', {
        confirmButtonText: 'Yes, Send',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      this.sendDirectLoading = true;
      await this.saveForm();
      await (0, _leadsProducts.addLeadsProducts)(this.leadsProductList);
      const res = await (0, _leads.sendDirectToClient)({
        id: this.leadId
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      if (error !== 'cancel') {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: error.toString()
        });
      }
    } finally {
      this.sendDirectLoading = false;
    }
  }
  async approveQuote() {
    try {
      this.approveLoading = true;
      await this.saveForm();
      let res = null;
      if (!this.previewPdfUrl) {
        await this.previewQuote(true);
      }
      res = await (0, _leads.approveQuote)({
        id: this.leadId
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.approveLoading = false;
    }
  }
  async previewQuote(preview = false) {
    try {
      this.previewLoading = preview;
      await this.saveForm();
      if (['Request Approval', 'Quote Rejected', 'Client Approved Options'].includes(this.lead.quotationStatus)
      // this.loggedInUser.email !== 'mubasshir@eiosys.com'
      ) {
        if (this.lead.quotationStatus === 'Request Approval' && this.lead.productAction === 'Send Options') {
          this.leadsProductList[0].isPreview = true;
        }
        await (0, _leadsProducts.addLeadsProducts)(this.leadsProductList);
      }
      const res = await (0, _leads.previewPdfUrl)(this.leadId);
      this.previewPdfUrl = res;
      const routeData = _router.default.resolve({
        path: '/quote-preview',
        query: {
          file: res
        }
      });
      window.open(routeData.href, '_blank');
      this.getList();
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.previewLoading = false;
    }
  }
  async rejectQuote() {
    try {
      this.rejectLoading = true;
      this.rejectDialogVisible = false;
      const res = await (0, _leads.rejectQuote)({
        id: this.leadId,
        reasonId: this.reasonId,
        rejectReason: this.rejectReason,
        rejectReasonComment: this.rejectReasonComment
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.rejectLoading = false;
    }
  }
  async previewPresentation() {
    try {
      this.previewLoading = true;
      const res = await (0, _leads.previewPresentationPdfUrl)(this.leadId);
      this.optionPreviewUrl = res;
      this.previewDialogVisible = true;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.previewLoading = false;
    }
  }
  async approveOptionsHandler() {
    try {
      this.approveLoading = true;
      const res = await (0, _leads.approveOptions)({
        id: this.leadId
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.approveLoading = false;
    }
  }
  async rejectOptionsHandler() {
    try {
      this.rejectLoading = true;
      this.rejectDialogVisible = false;
      const res = await (0, _leads.rejectOptions)({
        id: this.leadId,
        rejectReason: this.rejectReason,
        rejectReasonComment: this.rejectReasonComment
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.rejectLoading = false;
    }
  }
  async sendDirectOptionsToClientHandler() {
    try {
      await this.$confirm('Are you sure you want to send directly to client?', 'Confirmation', {
        confirmButtonText: 'Yes, Send',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      this.sendDirectLoading = true;
      await this.saveForm();
      await (0, _leadsProducts.addLeadsProducts)(this.leadsProductList);
      const res = await (0, _leads.sendDirectOptionsToClient)({
        id: this.leadId
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      if (error !== 'cancel') {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: error.toString()
        });
      }
    } finally {
      this.sendDirectLoading = false;
    }
  }
  async fetchProducts(query = '') {
    try {
      if (query.length > 0) {
        this.productList = await (0, _productsVariations.getVariations)((0, _index.getQuery)({
          limit: 10,
          enabled: true,
          productId: 0,
          name: query,
          filter: {
            enabled: '$eq',
            productId: '$gt',
            name: '$contL'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  showSelected(pid) {
    // get index of selected product
    const productIndex = this.productList.indexOf(pid);
    this.selectedProduct = this.productList[productIndex];
  }
  async removeRow(index, row) {
    if (['Request Approval', 'Request Options Approval', 'Quote Rejected'].includes(this.lead.quotationStatus) && this.leadsProductList.length < 2) {
      this.$notify({
        title: 'Warning',
        message: 'You can not delete all Products.',
        // 'Unable to remove, but you can set quantity as 0 to disable it',
        type: 'warning',
        duration: 3000
      });
      return;
    }
    // revise index as per rowspan
    if (!this.leadsProductList[index].id) {
      this.leadsProductList.splice(index, 1);
      this.addedProductIds.splice(index, 1);
    } else {
      try {
        await (0, _leadsProducts.deleteLeadsProduct)(this.leadsProductList[index].id);
        this.getList();
        this.leadsProductList.splice(index, 1);
        this.addedProductIds.splice(index, 1);
      } catch (error) {
        this.$notify({
          title: 'Warning',
          message: error.toString(),
          // 'Unable to remove, but you can set quantity as 0 to disable it',
          type: 'warning',
          duration: 3000
        });
      }
    }
  }
  async fetchReasonList(module = 'Quote') {
    try {
      this.reasonList = await (0, _reasons.getReasons)((0, _index.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        module: module,
        filter: {
          enabled: '$eq',
          module: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  calculate(index) {
    var _this$loggedInUser;
    const roleId = (_this$loggedInUser = this.loggedInUser) === null || _this$loggedInUser === void 0 ? void 0 : _this$loggedInUser.adminsRoleId;
    console.log('this role ', roleId);
    const row = this.leadsProductList[index];
    const unitPrice = row.unitPrice || 0;
    // --- NEW LOGIC: Enforce max discount for admin role 4 ---
    if (roleId === 4 && row.salePrice !== undefined && row.salePrice !== null) {
      const minAllowedPrice = unitPrice * this.negotiatedPriceLimitMultiplier;
      if (row.salePrice < minAllowedPrice) {
        // Force the price back to the minimum allowed
        // (Optional: You can also show an error/warning toast message here)
        row.salePrice = Number(minAllowedPrice.toFixed(2));
      }
    }
    // ------------------------------------------------------------
    let price = unitPrice;
    if (row.salePrice !== undefined && row.salePrice !== null && row.salePrice > 0) {
      price = row.salePrice;
    }
    const quantity = row.quantity || 0;
    // Instec: discount is a percentage off the unit rate, applied before multiplying by qty
    const discountPercentage = this.isInstec ? Math.min(100, Math.max(0, Number(row.discount) || 0)) : 0;
    const discountedRate = price * (1 - discountPercentage / 100);
    const subTotal = +(discountedRate * quantity).toFixed(2);
    const taxRate = row.taxRate || 0;
    const taxAmount = subTotal * taxRate / 100;
    const extraCharges = parseFloat(row.additionalChargesTotal) || 0;
    // Update row first
    this.$set(this.leadsProductList[index], 'discountAmount', +(price * quantity - subTotal).toFixed(2));
    this.$set(this.leadsProductList[index], 'subTotal', subTotal);
    this.$set(this.leadsProductList[index], 'taxAmount', taxAmount);
    this.$set(this.leadsProductList[index], 'total', +(subTotal + taxAmount + extraCharges).toFixed(2));
    // Recalculate order subtotal AFTER update
    const orderSubTotal = this.leadsProductList.reduce((sum, item) => {
      return sum + (Number(item.subTotal) || 0);
    }, 0);
    const totalQty = this.leadsProductList.reduce((sum, item) => {
      return sum + (Number(item.quantity) || 0);
    }, 0);
    if (this.lead) {
      this.$set(this.lead, 'totalQuality', totalQty);
    }
    if (this.lead) {
      this.$set(this.lead, 'subTotal', +orderSubTotal.toFixed(2));
      this.$set(this.lead, 'total', +orderSubTotal.toFixed(2));
      this.updateGrandTotal();
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      this.updateGrandTotal();
      const payload = {
        ...this.lead
      };
      // ⭐ remove relations
      delete payload.leadsProduct;
      delete payload.followUp;
      delete payload.client;
      delete payload.clientsContact;
      delete payload.salesCoordinator;
      delete payload.salesManager;
      delete payload.source;
      delete payload.category;
      delete payload.sample;
      await (0, _leads.updateLead)(this.lead.id, payload);
      // this.$notify({
      //   title: 'Success',
      //   message: 'Terms & Conditions saved',
      //   type: 'success',
      //   duration: 2000
      // })
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('lead.total')], default_1.prototype, "onLeadTotalChanged", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'QuoteProducts',
  components: {
    Enabled: _index2.default,
    LeadsProductGrid: _LeadsProductGrid.default,
    Editor: _tinymceVue.default
  }
})], default_1);
var _default = exports.default = default_1;